import React from 'react';
export function Footer() {
  return <footer className="bg-warm-brown-dark text-cream/80 py-12 px-4 text-center text-sm" data-id="element-52">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-53">
        <p className="font-heading text-xl text-cream" data-id="element-54">Alquimia del Linaje</p>

        <p data-id="element-55">
          Este producto es de carácter informativo y educativo. No reemplaza el
          diagnóstico ni el tratamiento médico o psicológico profesional.
        </p>

        <div className="flex justify-center gap-6 pt-6 border-t border-cream/20" data-id="element-56">
          <a href="#" className="hover:text-white transition-colors" data-id="element-57">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-58">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Contacto
          </a>
        </div>

        <p className="pt-4 opacity-60" data-id="element-60">
          © {new Date().getFullYear()} Alquimia del Linaje. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}